import React from 'react';
import dayjs from 'dayjs';
import { Table } from 'semantic-ui-react';
import { isNullOrUndefined } from '../../utils/siteFunctions';

const CustomReport = ({ customReportData }: CustomReportProps) => {
	return (
		<>
			{!isNullOrUndefined(customReportData) && (
				<Table celled>
					<Table.Header>
						<Table.Row>
							{customReportData?.data[0].map((x, index) => (
								<Table.HeaderCell key={index}>{x}</Table.HeaderCell>
							))}
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{customReportData?.data.slice(1).map((x, index) => (
							<Table.Row key={index}>
								{x.map((y, index) => (
									<Table.Cell key={index}>{y}</Table.Cell>
								))}
							</Table.Row>
						))}
					</Table.Body>
				</Table>
			)}
		</>
	);
};

export interface CustomReportProps {
	customReportData: CustomReportData | undefined;
}

export interface CustomReportData {
	data: any[][];
	footer: any[][];
}

export default CustomReport;